/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatorMemberPermissionModificationRequest } from '../models/CreatorMemberPermissionModificationRequest';
import type { CreatorPermissionView } from '../models/CreatorPermissionView';
import type { DetailedPermission } from '../models/DetailedPermission';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CreatorPermissionsApiService {
    /**
     * Get permissions for a specific creator
     * Retrieves all permissions currently assigned to a specific creator.
     * @returns CreatorPermissionView Permissions retrieved successfully
     * @throws ApiError
     */
    public static getAllPermissions({
        creatorId,
    }: {
        creatorId: number,
    }): CancelablePromise<CreatorPermissionView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/creators/{creatorId}/permissions',
            path: {
                'creatorId': creatorId,
            },
            errors: {
                403: `Forbidden`,
            },
        });
    }
    /**
     * Set permissions for a specific creator
     * Updates the permissions assigned to a specific creator.
     * @returns void
     * @throws ApiError
     */
    public static setAllPermissions({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: CreatorMemberPermissionModificationRequest,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/creators/{creatorId}/permissions',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Forbidden`,
            },
        });
    }
    /**
     * Get all available creator permissions
     * Retrieves the list of all possible permissions that can be assigned to a creator.
     * @returns DetailedPermission List of permissions retrieved successfully
     * @throws ApiError
     */
    public static getAllCreatorPermissions(): CancelablePromise<Array<DetailedPermission>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/creators/permissions',
        });
    }
}
